import { OrderModel } from '@onrunning/backstage-models';
import { OrderDocument } from './order-document.model';
import { OrderProduct } from './order-product.model';

export class Order extends OrderModel {
  public orderConfirmation?: OrderDocument = new OrderDocument();
  public products: OrderProduct[] = new Array<OrderProduct>();
  public selected?: boolean;
  public pricesAsync?: boolean;
}
